// Layout.jsx
import { Link } from "react-router-dom";
import { useLang } from "../utils/LangContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import LangChange from "./LangChange";

function Layout({ children }) {
  const { t } = useLang();
  const currentYear = new Date().getFullYear();

  return (
    <div className="d-flex flex-column vh-100">
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/public-games">
            Mainor
          </Link>
          <LangChange />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/mobile-requirements">
                  {t("Check requirements")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/public-games">
                  {t("Public Games")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  {t("Contact")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <main className="flex-grow-1 overflow-auto p-2 position-relative">
        {children}
      </main>

      <footer className="bg-dark text-white p-3 text-center">
        &copy; {currentYear} Mainor
      </footer>
    </div>
  );
}

export default Layout;
